import React from "react";
import styled from "styled-components";

const Song = ({ currentSong }) => {
let inx = 0;
	if(currentSong.name.indexOf('(') != -1)
	{
		inx = currentSong.name.indexOf('(');

		return (
					<SongContainer>
						<Img src={currentSong.cover} alt={currentSong.name}></Img>
						<H1>{currentSong.name.substring(0, inx)}<br/>{currentSong.name.substring(inx)}</H1>
						<H2>{currentSong.artist}</H2>
					</SongContainer>
				);
	}
	else{
		return (
		<SongContainer>
			<Img src={currentSong.cover} alt={currentSong.name}></Img>
			<H1>{currentSong.name}</H1>
			<H2>{currentSong.artist}</H2>
		</SongContainer>
	);
	}

};

const SongContainer = styled.div`
	margin-top: 10vh;
	min-height: 50vh;
	max-height: 60vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

const Img = styled.img`
	width: 20%;
	//border-radius: 50%;
	@media screen and (max-width: 768px) {
		width: 50%;
	}
`;

const H1 = styled.h2`
	padding: 3rem 1rem 1rem 1rem;
	text-align: center;
`;

const H2 = styled.h3`
	font-size: 1rem;
`;

export default Song;
